export default __webpack_public_path__ + "static/media/mauquenchy9.0e4a0bd8.jpg";